/** Kannada: job records kept by GigSync, the notice, Privacy's rows and "My work record". */
export const records = {
    "records.notice_kept": "GigSync ಏನು ಇಟ್ಟುಕೊಳ್ಳುತ್ತದೆ: ನಿಮ್ಮ ಕೆಲಸಗಳು, ಅವುಗಳ ದಿನಾಂಕ, ಕೆಲಸದ ಬಗೆ, ಬೆಲೆ, ಪಾವತಿಗಳು ಮತ್ತು ಸ್ಟಾರ್‌ಗಳು.",
    "records.notice_why": "ಏಕೆ: ನಿಮ್ಮ ಕೆಲಸದ ದಾಖಲೆ ನಿಮ್ಮದಾಗಿರಲು ಮತ್ತು ಅದನ್ನು ಎಲ್ಲಿಗೆ ಬೇಕಾದರೂ ತೆಗೆದುಕೊಂಡು ಹೋಗಲು, GigSync ಅನ್ನು ಉತ್ತಮಗೊಳಿಸಲು ಮತ್ತು ಕೆಲಸಗಾರರಿಗೆ ಬಹುಮಾನ ನೀಡಲು.",
    "records.notice_never": "ನಾವು ನಮ್ಮ ಸರ್ವರ್‌ಗಳಲ್ಲಿ ಫೋನ್ ಸಂಖ್ಯೆ, ವಿಳಾಸ ಅಥವಾ ಸಂಪರ್ಕ ಮಾಹಿತಿಯನ್ನು ಎಂದಿಗೂ ಇಡುವುದಿಲ್ಲ, ನೀವು ಬರೆದ ಯಾವುದನ್ನೂ ಇಡುವುದಿಲ್ಲ.",
    "records.notice_delete": "ಗೌಪ್ಯತೆಯಲ್ಲಿ ನಿಮ್ಮ ದಾಖಲೆಗಳನ್ನು ಯಾವಾಗ ಬೇಕಾದರೂ ಅಳಿಸಬಹುದು.",
    "records.agree": "ನಾನು ಒಪ್ಪುತ್ತೇನೆ",
    "records.not_now": "ಈಗ ಬೇಡ",
    "records.agree_failed": "GigSync ಸಂಪರ್ಕ ಸಿಗಲಿಲ್ಲ. ಇಂಟರ್ನೆಟ್ ಸಿಕ್ಕಾಗ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
    "records.signin_line": "ಮುಂದುವರಿಯುವ ಮೂಲಕ, ನೀವು GigSync ನ {link} ಒಪ್ಪುತ್ತೀರಿ",
    "records.signin_link": "ನಿಯಮಗಳು ಮತ್ತು ಗೌಪ್ಯತಾ ಸೂಚನೆಯನ್ನು",
    "records.terms_title": "ನಿಯಮಗಳು ಮತ್ತು ಗೌಪ್ಯತಾ ಸೂಚನೆ",
    "records.terms_writing": "GigSync ನ ನಿಯಮಗಳು ಮತ್ತು ಗೌಪ್ಯತಾ ಸೂಚನೆಯನ್ನು ಬರೆಯಲಾಗುತ್ತಿದೆ. ಅಲ್ಲಿಯವರೆಗೆ ಇದು ಅನ್ವಯಿಸುತ್ತದೆ:",
    "records.terms_about": "ನೀವು ಏನನ್ನು ಒಪ್ಪಿದ್ದೀರಿ, ಮತ್ತು GigSync ಏನನ್ನು ಇಡುತ್ತದೆ, ಏನನ್ನು ಎಂದಿಗೂ ಇಡುವುದಿಲ್ಲ.",
    "records.terms_back": "ಹಿಂದೆ",
    "records.consent_toast": "GigSync ಬಳಸುವುದು ಎಂದರೆ ನೀವು ಅದರ ನಿಯಮಗಳು ಮತ್ತು ಗೌಪ್ಯತಾ ಸೂಚನೆಯನ್ನು ಒಪ್ಪುತ್ತೀರಿ. ಅವುಗಳನ್ನು ಸೆಟ್ಟಿಂಗ್ಸ್‌ನಲ್ಲಿ ಓದಬಹುದು.",
    "records.privacy_title": "GigSync ಬಳಿ ನನ್ನ ದಾಖಲೆಗಳು",
    "records.privacy_kept": "GigSync ನಿಮ್ಮ ಕೆಲಸಗಳು, ದಿನಾಂಕ, ಕೆಲಸದ ಬಗೆ, ಬೆಲೆ, ಪಾವತಿಗಳು ಮತ್ತು ಸ್ಟಾರ್‌ಗಳನ್ನು ಇಡುತ್ತದೆ. ಫೋನ್ ಸಂಖ್ಯೆ, ವಿಳಾಸ ಅಥವಾ ನೀವು ಬರೆದದ್ದನ್ನು ಎಂದಿಗೂ ಇಲ್ಲ.",
    "records.privacy_off": "GigSync ನಿಮ್ಮ ಕೆಲಸಗಳ ದಾಖಲೆ ಇಡುತ್ತಿಲ್ಲ.",
    "records.privacy_agree": "ಓದಿ ಒಪ್ಪಿ",
    "records.delete": "GigSync ನಿಂದ ನನ್ನ ದಾಖಲೆಗಳನ್ನು ಅಳಿಸಿ",
    "records.delete_confirm_worker": "ಇದು GigSync ನಿಮಗಾಗಿ ಇಟ್ಟಿರುವ ಎಲ್ಲಾ ಕೆಲಸ, ಪಾವತಿ ಮತ್ತು ಸ್ಟಾರ್‌ಗಳನ್ನು ಅಳಿಸುತ್ತದೆ, ನಿಮ್ಮ ಕಾರ್ಡ್‌ನ ದಾಖಲೆ ಸೊನ್ನೆಗೆ ಬರುತ್ತದೆ. ನಿಮ್ಮ ಕೆಲಸಗಳು ಈ ಫೋನ್‌ನಲ್ಲಿ ಉಳಿಯುತ್ತವೆ. ನೀವು ಮತ್ತೆ ಒಪ್ಪುವವರೆಗೆ GigSync ಹೊಸದನ್ನು ಇಡುವುದಿಲ್ಲ.",
    "records.delete_confirm_household": "ಇದು GigSync ಇಟ್ಟಿರುವ ಪ್ರತಿ ಕೆಲಸದಿಂದ ನಿಮ್ಮ ಹೆಸರನ್ನು ತೆಗೆಯುತ್ತದೆ. ಕೆಲಸಗಾರರ ಬಳಿ ಅವರ ಭಾಗ ನೀವಿಲ್ಲದೆ ಉಳಿಯುತ್ತದೆ. ನಿಮ್ಮ ಕೆಲಸಗಳು ಈ ಫೋನ್‌ನಲ್ಲಿ ಉಳಿಯುತ್ತವೆ. ನೀವು ಮತ್ತೆ ಒಪ್ಪುವವರೆಗೆ GigSync ಹೊಸದನ್ನು ಇಡುವುದಿಲ್ಲ.",
    "records.delete_yes": "ಅಳಿಸಿ",
    "records.delete_cancel": "ಇರಲಿ",
    "records.deleted": "ಅಳಿಸಲಾಗಿದೆ. GigSync ಇನ್ನು ನಿಮ್ಮ ಕೆಲಸಗಳ ದಾಖಲೆ ಇಡುವುದಿಲ್ಲ.",
    "records.delete_failed": "ಅಳಿಸಲು ಆಗಲಿಲ್ಲ. ಇಂಟರ್ನೆಟ್ ಸಿಕ್ಕಾಗ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
    "records.show_failed": "ಬದಲಿಸಲು ಆಗಲಿಲ್ಲ. ಇಂಟರ್ನೆಟ್ ಸಿಕ್ಕಾಗ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
    "records.show_needs_card": "ಮೊದಲು ನಿಮ್ಮ ಕಾರ್ಡ್ ಅನ್ನು ಬೋರ್ಡ್‌ಗೆ ಹಾಕಿ.",
    "records.download_title": "ನನ್ನ ಕೆಲಸದ ದಾಖಲೆ ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ",
    "records.download_about": "GigSync ನಿಮಗಾಗಿ ಇಟ್ಟಿರುವ ಪ್ರತಿಯೊಂದು ಕೆಲಸ, ನೀವು ಸೈನ್ ಇನ್ ಮಾಡುವ ಯಾವುದೇ ಫೋನ್‌ನಲ್ಲಿ, ಯಾರಿಗಾದರೂ ತೋರಿಸಲು.",
    "records.export_loading": "ನಿಮ್ಮ ದಾಖಲೆ ತರುತ್ತಿದ್ದೇವೆ…",
    "records.export_failed": "ನಿಮ್ಮ ದಾಖಲೆ ತರಲು ಆಗಲಿಲ್ಲ. ಇಂಟರ್ನೆಟ್ ಸಿಕ್ಕಾಗ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
    "records.export_empty": "ಇನ್ನೂ ಯಾವ ಕೆಲಸವೂ ಇಟ್ಟಿಲ್ಲ. ನೀವು ಮತ್ತು ಮನೆಯವರು ಇಬ್ಬರೂ ಸಹಿ ಮಾಡಿದ ಕೆಲಸಗಳು ಇಲ್ಲಿ ಕಾಣುತ್ತವೆ.",
    "records.downloaded": "{file} ಎಂದು ಉಳಿಸಲಾಗಿದೆ.",
    "records.col_date": "ದಿನಾಂಕ",
    "records.col_work": "ಕೆಲಸ",
    "records.col_price": "ಬೆಲೆ (₹)",
    "records.col_paid": "ಬಂದದ್ದು (₹)",
    "records.col_method": "ಪಾವತಿ ಬಗೆ",
    "records.col_status": "ಸ್ಥಿತಿ",
    "records.col_stars": "ಸ್ಟಾರ್",
    "records.status_agreed": "ಒಪ್ಪಿದ್ದು",
    "records.status_done": "ಮುಗಿದಿದೆ",
    "records.status_cancelled": "ರದ್ದಾಗಿದೆ",
    "records.col_attested": "ಯಾರು ದೃಢಪಡಿಸಿದರು",
    "records.by_both": "ಇಬ್ಬರೂ",
    "records.by_you": "ನೀವು ಮಾತ್ರ",
};
//# sourceMappingURL=records.js.map